"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var IconWrapper = function IconWrapper(_ref) {
  var viewBox = _ref.viewBox,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: "activity-c-icon",
    fill: "none",
    viewBox: viewBox
  }, children);
};

IconWrapper.propTypes = {
  viewBox: _propTypes.PropTypes.string.isRequired,
  children: _propTypes.PropTypes.array.isRequired
};
var _default = IconWrapper;
exports.default = _default;